module.exports = "https://static.wmbcdn.com/uniweb/images/917d039f75831243b88b6bc8742121ec.svg";